export const HELP_LINK = 'https://help.innovorder.fr/';
